import type { BrandingConfigurationType } from '../../../branding/types'
import type { BeachPlanConfigurationType } from '../BeachPlanConfiguration/types/types'
import type { GeneralConfigurationType } from '../GeneralConfiguration/types/types'
import type { AvailabilityConfigurationType } from '../AvailabilityConfiguration/types/availability.types'
import type { PricingConfigurationType } from '../PricingConfiguration/types/pricingConfiguration.types'
import type { PaymentConfigurationType } from '../PaymentConfiguration/types/types'
import type { EmailConfigurationType } from '../EmailConfiguration/types/emailConfiguration.types'
import type { FeaturesConfigurationType } from '../FeaturesConfiguration/types/featuresConfiguration.types'

export const ConfigurationCategory = {
  BEACH_PLAN: 'beachPlan',
  GENERAL: 'general',
  AVAILABILITY: 'availability',
  PRICING: 'pricing',
  PAYMENT: 'payment',
  EMAIL: 'email',
  BRANDING: 'branding',
  FEATURES: 'features',
} as const
export type ConfigurationType = (typeof ConfigurationCategory)[keyof typeof ConfigurationCategory]

//export type ConfigurationType = 'beachPlan' | 'general' | 'availability' | 'priceList' | 'payment'

export type ConfigurationData =
  | BeachPlanConfigurationType
  | GeneralConfigurationType
  | AvailabilityConfigurationType
  | PricingConfigurationType
  | PaymentConfigurationType
  | EmailConfigurationType
  | BrandingConfigurationType
  | FeaturesConfigurationType
